import { BOOLEAN, DATE, FUNCTION, NUMBER, TEXT, STATUS } from './TypesConstants'
import { includes } from 'lodash'

const getFieldType = (field) => {
	const lowerCase = field.toLowerCase()
	if (includes(lowerCase, 'data')) {
		return BOOLEAN
	} else if (includes(lowerCase, 'date')) {
		return DATE
	} else if (includes(lowerCase, 'nb')) {
		return NUMBER
	} else if (includes(lowerCase, 'is')) {
		return BOOLEAN
	} else if (includes(lowerCase, 'function')) {
		return FUNCTION
	} else if (includes(lowerCase, 'state')) {
		return STATUS
	}
	return TEXT
}

export { getFieldType }



// WEBPACK FOOTER //
// ./src/utils/TypesUtils.js